import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class BrandService extends HeaderService {

    getAllBrands(page: number): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'brands/' + page,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createBrand(data): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'brand',
            JSON.stringify(data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    updateBrand(data, id): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'brand/' + id,
            JSON.stringify(data),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    deleteBrand(id): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'brand/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    getBrand(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'brand/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/brand.service.ts